const { newrelic } = window

const reportCustomAttributes = () => {
  if (typeof newrelic === 'object') {
    newrelic.setCustomAttribute('releaseVersion', process.env.RELEASE_VERSION)
  }
}

export default reportCustomAttributes
